/* Button link -- for button styles but implemented as a link element for accessiblity */
import { NavLink } from "react-router-dom";
import { arrowIcon } from "./partials/ArrowIcon";

const ButtonLink = ({ toLink, linkText, type = "primary" }) => {
  let buttonClass =
    "from-secondary-regular to-secondary-dark border-2 border-secondary-dark hover:from-[#B85EA0] hover:to-[#7E245A]";
  switch (type) {
    case "secondary":
      buttonClass =
        "from-primary-medium to-primary-deep border-2 border-primary-deep hover:from-[#6660CC] hover:to-[#47428C]";
      break;
    default:
      break;
  }
  return (
    <NavLink
      to={toLink}
      className={`group inline-flex items-center justify-center w-full transition-all ease-in-out duration-100 bg-gradient-to-r ${buttonClass} hover:rounded-[32px] text-white mt-4 py-4 px-6 rounded-md text-lg uppercase font-medium`}
    >
      {linkText}
      {arrowIcon}
    </NavLink>
  );
};

export { ButtonLink };
